import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { apiGetFile } from '../../../../../../generic/Api_Functions'
import { useSmartTranslation } from '../../../../../../generic/hooks/useSmartTranslation'
import { referenceThumbnailUrl } from '../../utils/jobDetailApi'

// Historia 160 (CA1.7, E9, D26/E-2) — "Foto ref." de la cabecera: la miniatura de la imagen principal
// de la referencia de pieza. Solo se pide si D1 dice `hasMainImage`; la clave `uuid` rompe la caché
// al cambiar de imagen (mismo patrón que `DeviceHeroImage`). Sin imagen, sin permiso o con la
// descarga fallida, el hueco dice "Sin imagen" y el detalle sigue: nunca es un error del detalle.

const SIZE = 64

const ReferenceThumbnail = ({ partReference = {} }) => {
  const { t_ } = useSmartTranslation()
  const [imageUrl, setImageUrl] = useState('')
  const partReferenceId = partReference.id
  const hasMainImage = partReference.hasMainImage === true
  const uuid = partReference.mainImageUuid || ''

  useEffect(() => {
    setImageUrl('')
    if (!hasMainImage || partReferenceId === undefined || partReferenceId === null) {
      return
    }
    let isCurrent = true
    let objectUrl = ''
    apiGetFile(referenceThumbnailUrl(partReferenceId, uuid))
      .then((response) => response.blob())
      .then((blob) => {
        if (!isCurrent) return
        objectUrl = URL.createObjectURL(blob)
        setImageUrl(objectUrl)
      })
      .catch(() => {
        if (isCurrent) setImageUrl('')
      })
    return () => {
      isCurrent = false
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [hasMainImage, partReferenceId, uuid])

  const frameSx = {
    width: SIZE,
    height: SIZE,
    flexShrink: 0,
    borderRadius: 1.5,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }

  if (imageUrl) {
    return (
      <Box sx={frameSx}>
        <img src={imageUrl} alt={t_('Reference image')} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </Box>
    )
  }
  return (
    <Box sx={{ ...frameSx, border: '1px dashed', borderColor: 'divider', px: 0.5 }} data-testid='reference-image-placeholder'>
      <Typography variant='caption' color='text.secondary' sx={{ textAlign: 'center', lineHeight: 1.2 }}>
        {t_('No image')}
      </Typography>
    </Box>
  )
}

ReferenceThumbnail.propTypes = {
  partReference: PropTypes.shape({
    id: PropTypes.number,
    hasMainImage: PropTypes.bool,
    mainImageUuid: PropTypes.string
  })
}

export default React.memo(ReferenceThumbnail)
